module.exports = __webpack_public_path__ + "static/img/help1.c56cdf9a.svg";